var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008511(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 14,
    viewBox: "0 0 70 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z",
    fill: "#F7B53C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0L22.5716 4.83688H27.6574L23.5429 7.82624L25.1145 12.6631L21 9.67376L16.8855 12.6631L18.4571 7.82624L14.3426 4.83688H19.4284L21 0Z",
    fill: "#F7B53C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 0L36.5716 4.83688H41.6574L37.5429 7.82624L39.1145 12.6631L35 9.67376L30.8855 12.6631L32.4571 7.82624L28.3426 4.83688H33.4284L35 0Z",
    fill: "#F7B53C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 0L50.5716 4.83688H55.6574L51.5429 7.82624L53.1145 12.6631L49 9.67376L44.8855 12.6631L46.4571 7.82624L42.3426 4.83688H47.4284L49 0Z",
    fill: "#F7B53C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0L64.5716 4.83688H69.6574L65.5429 7.82624L67.1145 12.6631L63 9.67376L58.8855 12.6631L60.4571 7.82624L56.3426 4.83688H61.4284L63 0Z",
    fill: "#F7B53C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008511);
export default __webpack_public_path__ + "static/media/Group 1000008511.45979ec10a65c11d6a9ab8fbc9db1a45.svg";
export { ForwardRef as ReactComponent };